export default "__VITE_ASSET__DXwi_ND$__"